import { useEffect, useState } from 'react';
import axios from 'axios';

// Set REACT_APP_API_URL at build time to point at a different backend.
export const API_BASE = process.env.REACT_APP_API_URL || 'https://api.cfbgami.com';

export interface Team {
  id: number;
  name: string;
}

export function useTeams() {
  const [teams, setTeams] = useState<Team[]>([]);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    axios.get<{ teams: Team[] }>(`${API_BASE}/api/teams/`, { signal: controller.signal })
      .then(response => setTeams(response.data.teams))
      .catch(() => {
        if (!controller.signal.aborted) setUnavailable(true);
      });
    return () => controller.abort();
  }, []);

  return { teams, unavailable };
}

export function scorePath(higher: number | string, lower: number | string, teamId: number | null = null) {
  const path = `/view_scores/${higher}/${lower}`;
  return teamId === null ? path : `${path}?team_id=${teamId}`;
}
